import { render, staticRenderFns } from "./InvitesSent.vue?vue&type=template&id=a68e34e0&"
import script from "./InvitesSent.vue?vue&type=script&lang=js&"
export * from "./InvitesSent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports